<template>
    <CHeader fixed with-subheader light>
        <CHeaderNav>
            <CHeaderNavItem>
                <CToggler in-header
                          class="ml-3 d-lg-none"
                          @click="$store.commit('toggleSidebarMobile')" />
                <CToggler in-header
                          class="ml-3 d-md-down-none"
                          @click="$store.commit('toggleSidebarDesktop')" />
                <CHeaderBrand class="mx-auto d-lg-none" to="/home">
                    <CIcon name="logo" height="48" alt="Logo" />
                </CHeaderBrand>
            </CHeaderNavItem>
            <CHeaderNavItem>
                <input id="headerItemSearch" name="itemSearch" type="text" class="form-control" placeholder="Search item by id" aria-label="Search item by id" v-on:keyup="searchById" />
            </CHeaderNavItem>
            <CHeaderNavItem class="pointer" v-on:click.native="performLookup">
                <CIcon name="cil-magnifying-glass" style="margin-left: 10px;" />
            </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderNav class="d-md-down-none mr-auto">
            <!--<CHeaderNavItem class="px-3">
          <CHeaderNavLink to="/home">
            HOME
          </CHeaderNavLink>
        </CHeaderNavItem>-->
        </CHeaderNav>
        
        <CHeaderNav class="mr-4">
            <LocaleSwitcher /> 
            <SsoApps />
            <!--<CHeaderNavItem class="d-md-down-none mx-2">
                <CHeaderNavLink>
                    <CIcon name="cil-bell" />
                </CHeaderNavLink>
            </CHeaderNavItem>-->

            <TheHeaderDropdownAccnt />
        </CHeaderNav>
        <CSubheader class="px-3">
            <CBreadcrumbRouter class="border-0 mb-0" />
        </CSubheader>
    </CHeader>
</template>

<script>
    import apis from '@/common/network';
    import LocaleSwitcher from '@/containers/LocaleSwitcher'
    
    import SsoApps from './SsoApps'
    import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

    export default {
        name: 'TheHeader',
        components: {
            LocaleSwitcher,
            TheHeaderDropdownAccnt,
            SsoApps
        },
        methods: {
            searchById: function (e) {
                if (e.key === 'Enter') {
                    this.performLookup();
                }
            },
            performLookup: function () {
                let lookupId = document.getElementById('headerItemSearch').value;
                let recordId = lookupId.substring(2);
                if (lookupId.startsWith('A_')) {
                    apis.protectedApi(`client/${recordId}`).then(clientResponse => {
                        if (clientResponse.status === 200) {
                            this.$router.push({ name: "Client", params: { clientId: recordId } });
                            document.getElementById('headerItemSearch').value = null;
                        }
                    });
                } else if (lookupId.startsWith('B_')) {
                    apis.protectedApi(`company/${recordId}`).then(companyResponse => {
                        if (companyResponse.status === 200) {
                            this.$router.push({ name: "Company", params: { clientId: recordId } });
                            document.getElementById('headerItemSearch').value = null;
                        }
                    });
                } else if (lookupId.startsWith('C_')) {
                    apis.protectedApi(`contract/${recordId}`).then(contractResponse => {
                        if (contractResponse.status === 200) {
                            this.$router.push({ name: "Contract", params: { contractId: recordId } });
                            document.getElementById('headerItemSearch').value = null;
                        }
                    });
                } else if (lookupId.startsWith('T_')) {
                    apis.protectedApi(`trade/${recordId}`).then(tradeResponse => {
                        if (tradeResponse.status === 200) {
                            this.$router.push({ name: "Trade", params: { tradeId: recordId } });
                            document.getElementById('headerItemSearch').value = null;
                        }
                    });
                } else if (lookupId.startsWith('G_')) {
                    apis.protectedApi(`tradingGroup/${recordId}`).then(tradingGroupResponse => {
                        if (tradingGroupResponse.status === 200) {
                            this.$router.push({
                                name: "TradingGroup",
                                params: { tradingGroupId: recordId }
                            });
                            document.getElementById('headerItemSearch').value = null;
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>